import moment from 'moment';

export default (qty) => {
  const years = [];
  const startYear = moment().year() - 13;
  for (let i = 0; i < qty; i += 1) {
    years.push(startYear - i);
  }

  return years;
};



// WEBPACK FOOTER //
// ./src/transforms/GenerateYears.js